(function () {

  /* =========================================================
     CATEGORIES COLLECTIONS
  ========================================================= */

  function initCategoriesCollections(root) {

    const sections =
      root &&
      root.matches?.('[data-categories-collections]')
        ? [root]
        : Array.from(
            (root || document).querySelectorAll(
              '[data-categories-collections]'
            )
          );


    sections.forEach(function (section) {

      if (!section) {
        return;
      }


      if (
        section.dataset
          .categoriesCollectionsInitialized ===
        'true'
      ) {
        return;
      }


      section.dataset
        .categoriesCollectionsInitialized =
        'true';


      const cursor =
        section.querySelector(
          '[data-category-cursor]'
        );


      const cards =
        Array.from(
          section.querySelectorAll(
            '[data-category-card]'
          )
        );


      if (
        !cursor ||
        !cards.length
      ) {
        return;
      }


      const desktopPointer =
        window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        );


      let activeCard =
        null;


      let cursorVisible =
        false;


      let rafId =
        null;


      let targetX =
        0;


      let targetY =
        0;


      /* =====================================================
         MOBILE / DESKTOP CHECK
      ===================================================== */

      function canUseCustomCursor() {

        return (
          desktopPointer.matches &&
          window.innerWidth > 749
        );

      }


      /* =====================================================
         APPLY CURSOR POSITION
      ===================================================== */

      function renderCursor() {

        rafId =
          null;


        if (
          !cursorVisible ||
          !canUseCustomCursor()
        ) {
          return;
        }


        cursor.style.left =
          targetX + 'px';


        cursor.style.top =
          targetY + 'px';

      }


      /* =====================================================
         REQUEST POSITION UPDATE
      ===================================================== */

      function requestCursorRender() {

        if (
          rafId !== null
        ) {
          return;
        }


        rafId =
          window.requestAnimationFrame(
            renderCursor
          );

      }


      /* =====================================================
         MOVE CURSOR
      ===================================================== */

      function moveCursor(event) {

        if (
          !canUseCustomCursor()
        ) {
          return;
        }


        targetX =
          event.clientX;


        targetY =
          event.clientY;


        requestCursorRender();

      }


      /* =====================================================
         SHOW CURSOR
      ===================================================== */

      function showCursor(
        card,
        event
      ) {

        if (
          !canUseCustomCursor()
        ) {
          return;
        }


        activeCard =
          card;


        cursorVisible =
          true;


        cursor.classList.add(
          'is-visible'
        );


        if (event) {

          targetX =
            event.clientX;


          targetY =
            event.clientY;


          requestCursorRender();

        }

      }


      /* =====================================================
         HIDE CURSOR
      ===================================================== */

      function hideCursor() {

        activeCard =
          null;


        cursorVisible =
          false;


        cursor.classList.remove(
          'is-visible'
        );


        if (
          rafId !== null
        ) {

          window.cancelAnimationFrame(
            rafId
          );


          rafId =
            null;

        }

      }


      /* =====================================================
         CARD EVENTS
      ===================================================== */

      cards.forEach(function (card) {

        const link =
          card.querySelector(
            '[data-category-link]'
          );


        if (!link) {
          return;
        }


        /* =================================================
           ENTER
        ================================================== */

        link.addEventListener(
          'pointerenter',
          function (event) {

            showCursor(
              card,
              event
            );

          }
        );


        /* =================================================
           MOVE
        ================================================== */

        link.addEventListener(
          'pointermove',
          function (event) {

            if (
              activeCard !== card
            ) {

              showCursor(
                card,
                event
              );


              return;

            }


            moveCursor(
              event
            );

          }
        );


        /* =================================================
           LEAVE
        ================================================== */

        link.addEventListener(
          'pointerleave',
          function () {

            if (
              activeCard === card
            ) {

              hideCursor();

            }

          }
        );

      });


      /* =====================================================
         SCROLL

         Hide cursor during page scrolling so it doesn't
         appear detached from the hovered collection.
      ===================================================== */

      window.addEventListener(
        'scroll',
        function () {

          if (
            cursorVisible
          ) {

            hideCursor();

          }

        },
        {
          passive: true
        }
      );


      /* =====================================================
         WINDOW LEAVE / BLUR
      ===================================================== */

      window.addEventListener(
        'blur',
        hideCursor
      );


      document.addEventListener(
        'mouseleave',
        hideCursor
      );


      /* =====================================================
         RESIZE
      ===================================================== */

      window.addEventListener(
        'resize',
        function () {

          if (
            !canUseCustomCursor()
          ) {

            hideCursor();

          }

        },
        {
          passive: true
        }
      );


      /* =====================================================
         MEDIA QUERY CHANGE
      ===================================================== */

      function handlePointerChange() {

        if (
          !canUseCustomCursor()
        ) {

          hideCursor();

        }

      }


      if (
        typeof desktopPointer
          .addEventListener ===
        'function'
      ) {

        desktopPointer.addEventListener(
          'change',
          handlePointerChange
        );

      } else if (
        typeof desktopPointer
          .addListener ===
        'function'
      ) {

        desktopPointer.addListener(
          handlePointerChange
        );

      }

    });

  }


  /* =========================================================
     NORMAL PAGE LOAD
  ========================================================= */

  function initialize() {

    initCategoriesCollections(
      document
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.matches?.(
          '[data-categories-collections]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-categories-collections]'
            );


      if (!section) {
        return;
      }


      delete section.dataset
        .categoriesCollectionsInitialized;


      initCategoriesCollections(
        section
      );

    }
  );

})();